import {create} from 'zustand';
export const useRenewalsStore = create((set) => ({
    renewalsByQuarter: null,
    renewalsByCustomer: null,
    renewalOffer: null,
    customers: null,
    setRenewalsByQuarter: (renewalsByQuarter) => set({ renewalsByQuarter }),
    setRenewalsByCustomer: (renewalsByCustomer) => set({ renewalsByCustomer }),
    setCustomers: (customers) => set({ customers }),
    setRenewalOffer: (renewalOffer) => set({ renewalOffer }),
    clearRenewals: () => set({
        renewalsByQuarter: null,
        renewalsByCustomer: null,
        renewalOffer: null,
        customers: null,
    }),
}));